<template>

  <section id="landing" class="home">

    <full-page ref="fullpage" class='home-slider-container' :class="{ active: borderactive }" :options="options">



      <div class="section" id="section0">
        <div class="slide project-preview-container" id="slide0" data-project="0">

                    <figcaption class="page-header-description topbottom">WORK</figcaption>
          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>Control Your Universe.</span></div>
                <div class="text-row"><span class="changeme">Any time, anywhere. Heating and cooling systems for
                    high-rise condos.</span></div>
              </h2>
              <router-link to="/work/universe" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>

            
            
            </div>
          </div>
          <video id="featuredvideo4" class="featuredvideo" data-project="headline4" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux.webm" type="video/webm" />
            <source src="@/assets/videos/unilux/Main-Page-Unilux.mp4" type="video/mp4" /> -->
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux.ogv" type="video/ogg" /> -->

            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux2.webm" type="video/webm" /> -->
                        <source src="@/assets/videos/unilux/Main-Page-Unilux2.mp4" type="video/mp4" />
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux-V2.mp4" type="video/mp4" /> -->
            <!-- <source src="@/assets/videos/unilux/Main-Page-Unilux2.ogv" type="video/ogg" /> -->
          </video>
        </div>
      </div>


      <div class="section" id="section1">
        <div class="slide project-preview-container" id="slide1" data-project="1">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Fast Way to Find your Flavour.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Thousands of displays ready to order.</span></div>
              </h2>

              <router-link to="/work/prepack-planner" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo5" class="featuredvideo" data-project="headline5" data-autoplay muted playsinline>
            <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" />
            <source src="@/assets/videos/mccormick/Main-Page-McCormick.mp4" type="video/mp4" />
                        <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick-V2.mp4" type="video/mp4" /> -->
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.ogv" type="video/ogg" /> -->
          </video>
        </div>
      </div>

      <div class="section" id="section4">
        <div class="slide project-preview-container" id="slide2" data-project="2">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Campaign that takes you Places.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Smiles that go on for miles.</span></div>
              </h2>

              <router-link to="/work/clarity" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            
            </div>
          </div>
        <video id="featuredvideo9" class="featuredvideo" poster="@/assets/videos/Main-Page-Clarity_Still.jpg" data-project="headline9" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-Clarity.mp4" type="video/mp4" />
          </video>
        </div>
      </div>


      <div class="section" id="section5">
        <div class="slide project-preview-container" id="slide3" data-project="3">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Food Safety Campaign that sees Beyond the Surface.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Accurate bacteria detection with speed.</span></div>
              </h2>

              <router-link to="/work/surface" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
           <video id="featuredvideo6" class="featuredvideo" poster="@/assets/videos/Main-Page-FoodSafety-Still.jpg" data-project="headline6" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-FoodSafety.mp4" type="video/mp4" />
          </video>
        </div>
      </div>



      <div class="section" id="section6">
        <div class="slide project-preview-container" id="slide4" data-project="4">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>A Trade In Program with Higher Returns.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Helping to bring bottom lines to new heights.</span></div>
              </h2>

              <router-link to="/work/higher" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
           <video id="featuredvideo7" class="featuredvideo" poster="@/assets/videos/Main-Page-Trade-Still.jpg" data-project="headline7" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-Trade.mp4" type="video/mp4" />
          </video>
        </div>
      </div>


      <div class="section" id="section7">
        <div class="slide project-preview-container" id="slide5" data-project="5">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span>Winning.</span></div>
                <!-- <div class="text-row"><span>Find your Flavour.</span></div> -->
                <div class="text-row"><span class="changeme">Connecting electrical professionals to 3M.</span></div>
              </h2>

              <router-link to="/work/winning" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <video id="featuredvideo8" class="featuredvideo" poster="@/assets/videos/Main-Page-UTS-Still.jpg" data-project="headline8" data-autoplay muted playsinline>
            <!-- <source src="@/assets/videos/mccormick/Main-Page-McCormick.webm" type="video/webm" /> -->
            <source src="@/assets/videos/Main-Page-UTS.mp4" type="video/mp4" />
          </video>
        </div>
      </div>




    </full-page>


  </section>

</template>

<script>
  export default {
    name: 'hello',
    metaInfo: {
      titleTemplate: 'Work by Branton  — A Creative Design Agency',
      meta: [{
        name: "Our Work",
        content: "Branton keeps our projects on a start-to-finish track that the entire team is on board with to ensure efficiency, quality and accountability. "
      }]
    },
    data() {
      return {
        options: {
          licenseKey: '7E4E7EAB-997043B6-8A86CC24-ABCA8700',
          sectionsColor: ['black', 'black'],
          scrollBar: true,
          fitToSection: false,
          scrollingSpeed: 800,
          fitToSectionDelay: 1000,
          touchSensitivity: 15,
          showActiveTooltip: true,
          navigation: false,
          lockAnchors: true,
          slidesNavigation: false,
          controlArrows: false,
          afterLoad: this.afterLoad,
        },
        indexForNormalScroll: 0,
        slideTimeout: 10000,
        borderactive: false,
        waitLoad: false,
        slideAnimation: false,
        slideTimer: '',
        slidePush: '',
        leavetime: '',
        headlinetimer: '',
      }
    },
    mounted() {

   this.$gtag.pageview({
        page_path: '/work',
      })

    },
    created() {
      window.addEventListener('scroll', this.scrollHandler);
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollHandler);
    },
    methods: {

      // eslint-disable-next-line
      afterLoad(origin, destination, direction) {
        var self = this;
        self.waitLoad = false;
        self.borderactive = false;
        self.clearTimers();
        if (destination.index === self.indexForNormalScroll) {
          // eslint-disable-next-line
          fullpage_api.setAutoScrolling(false);
        }
        var resetvideo = document.querySelectorAll('.project-preview-container');
        // eslint-disable-next-line    
        Array.prototype.forEach.call(resetvideo, function (elements, index) {
          elements.querySelector('.featuredvideo').currentTime = 0;
        });

        // console.log(origin.item.children[0].children[0]);
        let prevText = origin.item.children[0].children[0].children[0];
        prevText.classList.remove('section-animation-in');
        let currText = destination.item.children[0].children[0].children[0];
        currText.classList.add('section-animation-in');

      },
      // eslint-disable-next-line
      onSlideLeave(section, origin, destination, direction) {
        let self = this;
        var vid = document.getElementById("featuredvideo" + origin.item.dataset.project);
        vid.currentTime = 0;
        self.clearTimers();
      },
      clearTimers() {
        let self = this;
        clearTimeout(self.headlinetimer);
        clearTimeout(self.slidePush);
        clearTimeout(self.slideTimer);
        clearTimeout(self.leavetime);
      },
      scrollHandler() {
        var self = this;
        var normalSection = document.querySelectorAll(".section")[self.indexForNormalScroll];
        var offset = normalSection.offsetTop;
        let result = Math.ceil(self.getScrollTop());
        // eslint-disable-next-line
        if (result < offset && !fullpage_api.getFullpageData().options.autoScrolling) {
          // eslint-disable-next-line
          fullpage_api.setAutoScrolling(true);
        }
      },
      getScrollTop: function () {
        var doc = document.documentElement;
        return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      },
      moveSection(id) {
        // eslint-disable-next-line
        fullpage_api.moveTo(id + 1);
      }
    },
    watch: {}
  }
</script>

<style lang="scss">
  @import '@/assets/css/landing.scss';
</style>